import { render, staticRenderFns } from "./ProposteSoggiornoList.vue?vue&type=template&id=27d89f78&scoped=true&"
import script from "./ProposteSoggiornoList.vue?vue&type=script&lang=js&"
export * from "./ProposteSoggiornoList.vue?vue&type=script&lang=js&"
import style0 from "./ProposteSoggiornoList.vue?vue&type=style&index=0&id=27d89f78&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d89f78",
  null
  
)

export default component.exports